import React from 'react';

import PageHeader from '../../../../components/common/PageHeader';

import { LB_LOP_OVERTIME_MODULE } from '../../../../utils/constant/labels';

const { LB_LOP_OVERTIME_HEADER_TITLE } = LB_LOP_OVERTIME_MODULE;

const LopAndOvertimeRequestTools = () => {
  return <PageHeader headerTitle={LB_LOP_OVERTIME_HEADER_TITLE} />;
};

export default LopAndOvertimeRequestTools;
